import { AnyAction } from 'redux';
import { parseComponentTree } from 'lib/components/StoryBlok/factories';

import {
  FLEET_SWITCHING_TERMS_AND_CONDITIONS_SUCCESS,
  LOAD_ORG_FLEET_SWITCHING_CONFIG_SUCCESS,
} from './types';

export interface FSOrgConfig {
  drn: string;
  fleetSwitchingEligible: boolean;
  termsAndConditionsAccepted: boolean;
  branches: {
    drn: string;
    drnId: string;
    fleetSwitchingEligible: boolean;
    fleetSwitchingEnabled: boolean;
    name: string;
    orderwebId: number;
  }[];
}
export interface FleetSwitchingState {
  loading: boolean;
  TAndCContent?: any;
  configByOrgDrnId: { [orgDrnId: string]: FSOrgConfig };
}

const initialState: FleetSwitchingState = {
  loading: false,
  configByOrgDrnId: {},
};

export const FleetSwitchingReducer = (
  state: FleetSwitchingState = initialState,
  action: AnyAction,
) => {
  switch (action.type) {
    case FLEET_SWITCHING_TERMS_AND_CONDITIONS_SUCCESS:
      return {
        ...state,
        TAndCContent: parseComponentTree(action.payload.story.content),
      };
    case LOAD_ORG_FLEET_SWITCHING_CONFIG_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const { orgDrnID } = action.extra;

      return {
        ...state,
        configByOrgDrnId: {
          ...state.configByOrgDrnId,
          [orgDrnID]: action.payload,
        },
      };
    default:
      return state;
  }
};

export default FleetSwitchingReducer;
